export default function getShippingCountry(state) {
	return !!state.checkout.shipping.country ? state.checkout.shipping.country : null;
}



// WEBPACK FOOTER //
// ./src/store/utils/getShippingCountry.js